<script setup lang="ts">
import Logo from '@/assets/logo.svg'
</script>
<template>
  <div class="capture_logo font-eina02 weight_700 f-center">
    <Logo
      style="fill: var(--clr-primary); width: 1.25em; height: 1.25em"
      class="mr-1"
    />
    GTO Wizard
  </div>
</template>
